const isWhitespaceString = (str) => str.replace(/\s/g, "").length;
export default isWhitespaceString;
